<ion-list #list data-test="task-list">
	@for (task of tasks.uncompleted; track task) {
		<ion-item-sliding #item [class.filtered]="task.isFiltered">
			<ion-item-options side="start" (ionSwipe)="selectTask.emit(task)">
				<ion-item-option color="primary" expandable (click)="selectTask.emit(task)">
					@if (task.hasUserHandlePermission && canUpdateTask(task)) {
						<i class="fa fa-comment option__icon"></i>
					} @else {
						<i class="fa fa-warning option__icon"></i>
					}
				</ion-item-option>
			</ion-item-options>

			<ion-item data-test="task-swipe-item" lines="none" slot="start" (click)="selectTask.emit(task)">
				<ic-task-item
					data-test="uncompleted-task"
					[current]="shift.id === task.shift"
					[enabled]="task.hasUserHandlePermission && canUpdateTask(task)"
					[shiftId]="shift.id"
					[task]="task"
				/>
			</ion-item>

			<ion-item-options side="end" (ionSwipe)="onTaskSwipe(task); list.closeSlidingItems()">
				<ion-item-option
					color="primary"
					data-test="task-swipe-confirm"
					expandable
					[ngClass]="{ warning: !task.hasUserHandlePermission || !canUpdateTask(task) }"
					(click)="onTaskSwipe(task); list.closeSlidingItems()"
				>
					@if (task.hasUserHandlePermission && canUpdateTask(task)) {
						<i class="fa fa-check option__icon"></i>
					} @else {
						<i class="fa fa-warning option__icon"></i>
					}
				</ion-item-option>
			</ion-item-options>
		</ion-item-sliding>
	}
</ion-list>
